function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs300"
}, /*#__PURE__*/React.createElement("style", {
  id: "style298"
}, ".cls-1{fill:#db1a1a;}.cls-2{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_127",
  "data-name": "Group 127",
  transform: "translate(-135.67,-83.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_36",
  "data-name": "Path 36"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#db1a1a",
  d: "m 248.55,399 c -8.59,-11.6 -30.66,-42 -52.49,-76.71 -36.43,-58 -55.69,-101.61 -55.69,-126.21 a 108.18,108.18 0 1 1 216.36,0 c 0,24.6 -19.26,68.24 -55.68,126.21 -21.84,34.71 -43.91,65.06 -52.5,76.71 z",
  id: "path302"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M 248.55,92.56 A 103.47,103.47 0 0 0 145.07,196 c 0,16.53 9.53,51.4 54.93,123.65 C 219.07,350 238.32,377 248.55,391 258.78,377 278.04,350 297.1,319.66 342.5,247.43 352,212.56 352,196 A 103.47,103.47 0 0 0 248.55,92.56 m 0,-9.41 A 112.88,112.88 0 0 1 361.43,196 c 0,62.35 -112.88,210.78 -112.88,210.78 0,0 -112.88,-148.4 -112.88,-210.78 A 112.88,112.88 0 0 1 248.55,83.15 Z",
  id: "path304"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_125",
  "data-name": "Group 125"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  fill: "#fff",
  d: "M 291,169.87 268.26,146.8 c -12.12,4.11 -54.62,6.27 -44.92,39.51 0,0.1 0,0.19 0,0.3 h 12.87 a 2.81,2.81 0 0 1 0.3,-0.81 15.61,15.61 0 0 1 12.72,-7.88 16.16,16.16 0 0 1 14.29,7.58 2.58,2.58 0 0 1 -0.2,3.23 l -2.53,2.52 -16.93,16.94 a 6.78,6.78 0 0 0 -1.32,8.08 6.59,6.59 0 0 0 9.1,2 6.9,6.9 0 0 0 0.95,-0.74 l 15.55,-15.81 6.36,-6.46 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  fill: "#fff",
  d: "m 299.26,169.88 c 1.7,0 1.88,-1.18 7.47,-6.46 a 2.51,2.51 0 0 0 0,-3.54 v 0 c -28.91,-28.5 -27.81,-28.76 -29.83,-28.76 a 2.52,2.52 0 0 0 -1.77,0.76 c -4.95,5.27 -6.25,5.49 -6.25,7.32 0,1.48 1.09,2 1.71,2.82 0.5,0.29 26.34,26.67 26.86,27.16 a 3.18,3.18 0 0 0 1.81,0.75 z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  fill: "#fff",
  d: "m 240.61,205.36 c 0,0 14.37,-14.56 14.33,-14.6 h -48.75 a 2.35,2.35 0 0 0 -2.39,2.33 v 50.18 a 2.35,2.35 0 0 0 2.33,2.39 h 62.22 a 2.4,2.4 0 0 0 2.39,-2.39 v -37.72 l -15.14,15.37 a 10.89,10.89 0 0 1 -7.73,3.2 10.78,10.78 0 0 1 -8.77,-16.93 13.62,13.62 0 0 1 1.51,-1.79 z m -1.51,1.79 a 12.54,12.54 0 0 1 1.46,-1.79 13.12,13.12 0 0 0 -1.46,1.79 z"
})));

var SvgEarlyvoting = function SvgEarlyvoting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bold",
    viewBox: "0 0 225.75999 323.63",
    width: 225.75999,
    height: 323.63,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEarlyvoting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/earlyvoting.88344123.svg";
export { ForwardRef as ReactComponent };